window.addEventListener('load', function () {
  console.log('script loaded');

  const menuLinks = document.querySelectorAll('.mega-menu-custom-nav a');
  console.log('links found:', menuLinks.length);

  // Set active on page load based on current URL
  menuLinks.forEach(function (link) {
    if (link.href === window.location.href) {
      link.classList.add('active-link');
    }
  });
});